export interface GossipItem {
  id: number;
  rank: number;
  tag: string;
  tagType: "hot" | "new" | "deep";
  title: string;
  excerpt: string;
  cover: string;
  heat: string;
  comments: string;
  time: string;
}

export interface InsiderItem {
  id: number;
  category: string;
  title: string;
  brief: string;
  cover: string;
  status: string;
}

export interface DiscussionItem {
  id: number;
  title: string;
  snippet: string;
  commentCount: string;
  agree: string;
  time: string;
}

export const heroCover =
  "https://readdy.ai/api/search-image?query=Moody%20editorial%20collage%20of%20anonymous%20newsroom%20materials%20glowing%20smartphone%20screens%20scattered%20papers%20magnifying%20glass%20and%20dark%20envelopes%20with%20warm%20vermillion%20and%20amber%20spotlights%20on%20near%20black%20background%2C%20cinematic%20depth%2C%20high%20contrast%2C%20grainy%20texture%2C%20abstract%20journalism%20theme&width=1600&height=900&seq=hero-gossip-2026&orientation=landscape";

export const gossipItems: GossipItem[] = [
  {
    id: 1,
    rank: 1,
    tag: "深扒",
    tagType: "deep",
    title: "连锁餐饮后厨被曝使用临期冻肉，内场员工晒出整月监控截图",
    excerpt:
      "一位自称后厨主管的匿名爆料人投来连续 27 天的采购与出餐记录，指证部分门店为压成本更换临期食材供应商，并附上了当晚的进货单据。",
    cover:
      "https://readdy.ai/api/search-image?query=Dimly%20lit%20commercial%20restaurant%20kitchen%20with%20stacked%20frozen%20meat%20boxes%20and%20thermometer%20near%20a%20grill%2C%20warm%20vermillion%20accent%20lighting%2C%20gritty%20documentary%20style%2C%20editorial%20photography%2C%20moody%20and%20tense%20atmosphere&width=1200&height=800&seq=gossip-c1&orientation=landscape",
    heat: "38.2万",
    comments: "4200",
    time: "2小时前",
  },
  {
    id: 2,
    rank: 2,
    tag: "热议",
    tagType: "hot",
    title: "一线房企交付期再跳票，业主群流传出内部工程节点排期表",
    excerpt:
      "多地准业主集中反馈楼盘交付再次延期。有投递者晒出疑似内部盖章的工程排期，直指资金链与分包结算问题，评论区业主已开始接力核对自己所在楼栋。",
    cover:
      "https://readdy.ai/api/search-image?query=Construction%20site%20of%20an%20unfinished%20residential%20tower%20with%20cranes%20and%20scaffolding%20at%20dusk%2C%20warm%20amber%20and%20vermillion%20sky%2C%20documentary%20editorial%20photography%2C%20slightly%20ominous%20mood%2C%20high%20detail&width=1200&height=800&seq=gossip-c2&orientation=landscape",
    heat: "29.7万",
    comments: "3900",
    time: "4小时前",
  },
  {
    id: 3,
    rank: 3,
    tag: "新料",
    tagType: "new",
    title: "头部直播机构运营玩法再引争议：话术库曝光，剧本痕迹明显",
    excerpt:
      "一段长达两小时的下播录音与内部话术文档被投递，详细记录所谓「真实体验」背后的统一话术模板。爆料人称自己曾在机构任职三个月，愿配合后续补充证据。",
    cover:
      "https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20chaotic%20live%20streaming%20studio%20with%20ring%20lights%20phones%20and%20script%20pages%20scattered%20on%20desk%2C%20warm%20crimson%20and%20amber%20light%2C%20documentary%20editorial%20photography%2C%20high%20contrast&width=1200&height=800&seq=gossip-c3&orientation=landscape",
    heat: "18.5万",
    comments: "2700",
    time: "6小时前",
  },
  {
    id: 4,
    rank: 4,
    tag: "内幕",
    tagType: "deep",
    title: "网红茶饮被指「一夜走红」全靠买榜，投放明细与成交数据对不上",
    excerpt:
      "爆料内容包含多张渠道投放结算截图，声称部分门店排队盛况与真实成交存在较大出入。平台侧暂未回应，相关地区已出现「预约到店」新玩法试探反应。",
    cover:
      "https://readdy.ai/api/search-image?query=Busy%20trendy%20bubble%20tea%20shop%20with%20long%20line%20of%20customers%20at%20night%20neon%20signs%20glowing%20warm%20orange%20and%20red%2C%20street%20photography%20editorial%20style%2C%20slightly%20blurred%20crowd%2C%20documentary%20feel&width=1200&height=800&seq=gossip-c4&orientation=landscape",
    heat: "15.3万",
    comments: "2100",
    time: "8小时前",
  },
];

export const insiderItems: InsiderItem[] = [
  {
    id: 1,
    category: "独家",
    title: "某头部教培重组的「三个没说出口的真相」正在核对中",
    brief: "收到分段录音与离职补偿草案，正在逐条比对公开口径与内部文件差异。",
    cover:
      "https://readdy.ai/api/search-image?query=Stack%20of%20confidential%20documents%20and%20audio%20recorder%20on%20office%20desk%20under%20a%20single%20warm%20desk%20lamp%2C%20vermillion%20ambient%20glow%2C%20documentary%20editorial%20photography%2C%20confidential%20intrigue%20mood%2C%20portrait%20orientation&width=900&height=1100&seq=insider-1&orientation=portrait",
    status: "核验中",
  },
  {
    id: 2,
    category: "深料",
    title: "供应链回扣线索：供货商称多轮报价「先问关系再定价」",
    brief: "附带三年合作邮件与报价差异对比，指向多项目采购环节，波及数家乙方。",
    cover:
      "https://readdy.ai/api/search-image?query=Close%20up%20of%20business%20contracts%20and%20a%20red%20rubber%20stamp%20with%20calculator%20under%20warm%20amber%20desk%20lamp%2C%20suspenseful%20editorial%20photography%2C%20warm%20vermillion%20and%20ochre%20tones%2C%20portrait&width=900&height=1100&seq=insider-2&orientation=portrait",
    status: "补料中",
  },
  {
    id: 3,
    category: "新证",
    title: "旧案新料：去年那条「被撤热搜」的贴文，原作者站出来了",
    brief: "当事人愿意实名作证但不露脸，提供全程后台录屏与申诉时间线，可信度较高。",
    cover:
      "https://readdy.ai/api/search-image?query=Hands%20of%20an%20anonymous%20person%20typing%20on%20laptop%20at%20night%2C%20screen%20glow%20reflecting%20warm%20red%20tones%2C%20screen%20recording%20theme%2C%20editorial%20documentary%20photography%2C%20dark%20and%20moody%2C%20portrait&width=900&height=1100&seq=insider-3&orientation=portrait",
    status: "待排期",
  },
];

export const discussionItems: DiscussionItem[] = [
  {
    id: 1,
    title: "你觉得「匿名爆料」最该先保护谁？爆料人、当事人还是围观者？",
    snippet:
      "评论区吵翻天了。有人支持先做事实核查再放瓜，有人认为速度更重要——这条的留言已经滚到 900 多条。",
    commentCount: "900+",
    agree: "76%",
    time: "3小时前",
  },
  {
    id: 2,
    title: "同城群里疯传的那份「拒稿理由」，你站投稿人还是平台？",
    snippet:
      "一位投稿人晒出被退回的线索与理由截图，认为审核尺度太飘忽；编辑在下方逐条回应，火药味很足。",
    commentCount: "540",
    agree: "58%",
    time: "5小时前",
  },
  {
    id: 3,
    title: "爆料带「实锤」到底要多锤？聊聊你见过的翻车名场面",
    snippet:
      "从截图被P到时间线对不上，网友在线拆解这些年吃瓜翻车的经典案例，笑中带泪。",
    commentCount: "380",
    agree: "61%",
    time: "7小时前",
  },
  {
    id: 4,
    title: "如果拿到一手内部文件，你会先投稿还是先自己吃透？",
    snippet:
      "匿名通道里最常被问的一句话。有老瓜民晒出「如何让线索更可信」的自制清单，被疯狂转走。",
    commentCount: "220",
    agree: "69%",
    time: "9小时前",
  },
];

export const hotTags: string[] = [
  "餐饮后厨", "房企交付", "直播话术", "网红店买榜", "教培重组",
  "供应链回扣", "旧案新料", "内部文件", "排期造假", "打卡翻车",
];